import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StartComponent } from './start.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: StartComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class StartRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/start/start-routing.module.ts